import { useEffect, useState } from 'react';
import { imperial, pressU, depU, depToM, mToDep, locale } from '../lib/units';

// number input shown in the user's unit, stored in the internal unit (bar / m)
const CONV = {
  press: { u: pressU, toU: (v) => (imperial() ? v * 14.5038 : v), toI: (v) => (imperial() ? v / 14.5038 : v), d: 2 },
  dep: { u: depU, toU: mToDep, toI: depToM, d: 0 },
};
const show = (v, c) => (v == null || v === '' || Number.isNaN(+v) ? '' : (+c.toU(+v).toFixed(c.d + 1)).toLocaleString(locale(), { maximumFractionDigits: c.d + 1, useGrouping: false }));

export default function UnitInput({ kind, value, onChange, testid, ph, autoFocus }) {
  const c = CONV[kind];
  const [txt, setTxt] = useState(() => show(value, c));
  useEffect(() => { const cur = txt.replace(',', '.'); if (cur === '' ? value != null && value !== '' : Math.abs(c.toI(+cur) - +value) > 1e-6) setTxt(show(value, c)); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <input inputMode="decimal" data-testid={testid} autoFocus={autoFocus} value={txt} placeholder={ph ?? c.u()}
      onChange={(e) => { const s = e.target.value; setTxt(s); const n = parseFloat(s.replace(',', '.')); onChange(s.trim() === '' || Number.isNaN(n) ? '' : String(+c.toI(n).toFixed(6))); }} />
  );
}
